import React from 'react';
import LandingHeader from '../LandingHeader';
import Footer from '../sections/Footer/Footer';
import '../LandingPage.css';

const PublicPageLayout = ({ history, children }) => (
  <div className="landing-page">
    <LandingHeader history={history} fullWidth />
    <main className="pre-auth-page-content">
      {children}
    </main>
    <Footer />
  </div>
);

export default PublicPageLayout;
